import { SET_ACTIVE_THREAD } from "./ActiveThreadType";

// redux/Messages/ActiveThreadReducer.js
const initialState = null;

export default function activeThreadReducer(state = initialState, action) {
  switch (action.type) {
    case "SET_ACTIVE_THREAD":
      return action.payload; // the full thread object
    default:
      return state;
  }
}